import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EnelytixBillingState, BillingFilter, BillingGridData } from "./types";

const initialState: EnelytixBillingState = {
    showSidebar: true,
    showGridSpinner: false,
    gridSource: {
        data: null,
        total: 0,
        filter: {
            startDate: null,
            endDate: null,
            searchString: null,
            pageNumber: 1,
            pageSize: 30,
        },
    },
};

const enelytixBillingSlice = createSlice({
    name: "enelytixBilling",
    initialState,
    reducers: {
        setGridSource(state, action: PayloadAction<{ data: BillingGridData[]; total: number; filter: BillingFilter }>) {
            state.gridSource.data = action.payload.data;
            state.gridSource.total = action.payload.total;
            state.gridSource.filter = action.payload.filter;
        },
        changeFilter(state, action: PayloadAction<Partial<BillingFilter>>) {
            state.gridSource.filter = {
                ...state.gridSource.filter,
                ...action.payload,
            };
        },
        toggleGridSpinner(state, action: PayloadAction<boolean>) {
            state.showGridSpinner = action.payload;
        },
        resetView(state) {
            state = { ...initialState };
        },
    },
});

export const actions = enelytixBillingSlice.actions;
export default enelytixBillingSlice.reducer;
